import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import {
  CustomButton,
  CustomPopper,
  FilterCard,
  SvgContainer,
} from "../../components";
import theme from "../../theme/theme";
import { FILTER, LIST } from "../../assets/icons";
import BaraTable from "./component/BaraTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/state";
import { useNavigate } from "react-router-dom";

function Bara() {
  const offres = useSelector((state: RootState) => Object.values(state.offre));
  const grouilleurs = useSelector((state: RootState) =>
    Object.values(state.grouilleur)
  );

  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);

  const dispatch = useDispatch();

  const handleShowOpen = () => {
    setShow((prev) => !prev);
  };

  const onDetail=(item: any) => {
    navigate("/bara/bara-detail/"+item.id)
  };

  const onSelectFilter = (item: any) => {
    handleShowOpen();
    setSelectedFilter(item);
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("list_bara")}
        </Typography>
        <Stack direction={"row"} spacing={2}>
          <CustomPopper
            onClose={handleShowOpen}
            icon={
              <CustomButton
                title={i18n.t("filtrer_par")}
                rightComponent={
                  <SvgContainer
                    svg={FILTER}
                    color={theme.colors.white}
                    width={15}
                  />
                }
                titleStyle={{ marginRight: 1 }}
                rootStyle={{ backgroundColor: theme.colors.black, height: 45 }}
              />
            }
            containerStyle={{ padding: 0, borderRadius: "5px" }}
            buttonStyle={{
              backgroundColor: "transparent",
              width: "100%",
              padding: 0,
            }}
          >
            <Box
              p={2}
              sx={{
                height: "400px",
                width: "300px",
                position: "relative",
                overflow: "auto",
              }}
            >
              {grouilleurs.map((item: any) => (
                <FilterCard
                  key={item.id}
                  item={item}
                  onClick={() => onSelectFilter(item)}
                />
              ))}
            </Box>
          </CustomPopper>
          <CustomButton
            title={i18n.t("exporter_liste")}
            leftComponent={
              <SvgContainer svg={LIST} color={theme.colors.white} width={15} />
            }
            titleStyle={{ marginLeft: 1 }}
            rootStyle={{ backgroundColor: "#3D423F", height: 45 }}
          />
        </Stack>
      </Stack>
      <BaraTable data={offres} onDetail={onDetail} />
    </Box>
  );
}

export default Bara;
